var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "avue-form",
    {
      ref: "formUnit",
      attrs: {
        option: _vm.optionUnit,
        "upload-after": _vm.uploadAfter,
        "upload-before": _vm.onUploadBefore,
      },
      on: { submit: _vm.submitUnit, "reset-change": _vm.onRestChange },
      model: {
        value: _vm.formUnit,
        callback: function ($$v) {
          _vm.formUnit = $$v
        },
        expression: "formUnit",
      },
    },
    [
      _c(
        "template",
        { slot: "unit_name" },
        [
          _c("el-autocomplete", {
            ref: "unitName",
            staticStyle: { width: "100%" },
            attrs: {
              debounce: 0,
              "fetch-suggestions": _vm.querySearch,
              "trigger-on-focus": true,
              clearable: "",
              placeholder: "请填写 企业名称",
            },
            on: { clear: _vm.onUnitNameClear, select: _vm.unitChanged },
            model: {
              value: _vm.formUnit.unit_name,
              callback: function ($$v) {
                _vm.$set(_vm.formUnit, "unit_name", $$v)
              },
              expression: "formUnit.unit_name",
            },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }